/*
 * Workflows: a status that changes along a scheme, with its history and its dialogs. The page
 * under Administration lists them and configures them.
 * The front-end manifest, see lib/docs/extensions/writing-an-extension.md and lib/docs/extensions/workflow/concept.md.
 */
import { defineExtension } from '@lib/extensions/define';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'workflow',
	locale: { de, en },
	routes: [
		{
			path: 'admin/workflows',
			name: 'workflow.settings',
			component: () => import('./pages/Workflows.vue'),
			// The page itself only reads; the Save asks for config('workflow.permission').
			meta: { permissions: ['app.settings'] },
		},
	],
	// The app places extensionMenu('admin', ...) in its own menu
	sidebar: {
		admin: () => [
			{ to: '/admin/workflows', icon: 'fa-diagram-project', label: 'workflows', permissions: ['app.settings'] },
		],
	},
});
